// rules.jsx — shown after picking Computer mode on /modes, before the game starts.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MODE_CPU,
  setSelectedGameMode,
  startFreshCpuGame,
} from "../../game/gameModeStorage";
import { CPU_MAX_GAMES, fetchCpuStatus } from "../../functions/connect4Cpu";
import { CONNECT4_RULES } from "./connect4Rules";
import "../modes/modes.css";
import "./rules.css";

const LOGO_SRC = `${process.env.PUBLIC_URL}/img/game-logo.png`;

function readUserData() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

function UserRules() {
  const navigate = useNavigate();
  const [gamesLeft, setGamesLeft] = useState(null);
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.documentElement.classList.add("modes-static-bg");
    document.body.classList.add("modes-static-bg");
    return () => {
      document.documentElement.classList.remove("modes-static-bg");
      document.body.classList.remove("modes-static-bg");
    };
  }, []);

  useEffect(() => {
    let active = true;
    fetchCpuStatus()
      .then((s) => active && setGamesLeft(Number(s.gamesLeft) || 0))
      .catch((e) => {
        console.error("Could not load CPU game status:", e);
        if (active) setError("Could not load your games. Please try again.");
      });
    return () => {
      active = false;
    };
  }, []);

  const handleStart = async () => {
    if (starting) return;
    setStarting(true);
    setError("");
    try {
      const status = await fetchCpuStatus();
      const left = Number(status.gamesLeft) || 0;
      setGamesLeft(left);
      if (left <= 0) return;

      const userData = readUserData();
      const userId = String(
        userData?.userId ?? userData?.userid ?? userData?.id ?? ""
      ).trim();
      const name = String(userData?.name ?? "").trim() || "You";
      setSelectedGameMode(MODE_CPU);
      startFreshCpuGame(userId, name);
      navigate("/game", { replace: true });
    } catch (e) {
      console.error("Could not start CPU game:", e);
      setError("Could not start the game. Please try again.");
    } finally {
      setStarting(false);
    }
  };

  const outOfGames = gamesLeft === 0;

  return (
    <div className="c4-rules-page">
      <img className="c4-rules-logo" src={LOGO_SRC} alt="Connect 4 Showdown" />
      <div className="c4-rules-card">
        <h1 className="c4-rules-title">How to Play</h1>
        <ol className="c4-rules-list">
          {CONNECT4_RULES.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ol>

        {outOfGames ? (
          <p className="c4-rules-games-left">
            You have played all {CPU_MAX_GAMES} games.
          </p>
        ) : null}
        {error ? (
          <p className="c4-rules-error" role="alert">
            {error}
          </p>
        ) : null}

        <div className="c4-rules-actions">
          <button
            type="button"
            className="c4-rules-btn"
            onClick={handleStart}
            disabled={starting || outOfGames}
          >
            {starting ? "Starting…" : "Start Game"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserRules;
